module.exports = "<ul class=\"weui_media_info\"><slot></slot></ul>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/media/media-info.vue
 ** module id = 171
 ** module chunks = 0
 **/